import request from '@/utils/request'

// getmActList
export function getmActList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6500/getmActList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epms6500List
export function epms6500List(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6500/epms6500List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms6500Xls
export function epms6500Xls(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6500/epms6500Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms6500Xls RES', res)

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Console Material List.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}